import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=8c9b281e&scoped=true&"
import script from "./Vip.vue?vue&type=script&lang=js&"
export * from "./Vip.vue?vue&type=script&lang=js&"
import style0 from "./Vip.vue?vue&type=style&index=0&id=8c9b281e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b281e",
  null
  
)

export default component.exports